import script from "./PostDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostDetailView.vue?vue&type=script&setup=true&lang=js"

import "./PostDetailView.vue?vue&type=style&index=0&id=4ce10ab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce10ab4"]])

export default __exports__